import { Trans, i18nMark } from '@lingui/react'
import { SectionType } from 'common-proptypes'
import CourseLesson from './CourseLesson.jsx'

import styles from './CourseSection.module.scss'

export default class CourseSection extends React.PureComponent {
  static propTypes = {
    section: SectionType.isRequired,
    lockReason: PropTypes.string,
    lessonProps: PropTypes.object,
  }

  render() {
    const {
      section,
      lockReason,
      lessonProps,
    } = this.props
    const {
      name,
      complete,
      items,
      userCurriculumAssignmentId,
      curriculumSectionId,
      forceLinearCompletion,
    } = section

    function getLessonLockedReason(lesson) {
      if(lockReason) {
        return lockReason
      }
      if(!forceLinearCompletion) {
        return null
      }
      if(lesson.complete) {
        return null
      }
      const previousLesson = items[items.indexOf(lesson) - 1]
      if(!previousLesson) {
        return null
      }
      if(!previousLesson.complete) {
        return i18nMark('This lesson will unlock when the previous lesson is completed.')
      }
      return null
    }

    const $items = items.map(item => (
      <CourseLesson
        key={item.id}
        {...lessonProps}
        lesson={item}
        userCurriculumAssignmentId={userCurriculumAssignmentId}
        curriculumSectionId={curriculumSectionId}
        lockReason={getLessonLockedReason(item)}
      />
    ))
    return (
      <section className={cx(styles.container, { complete }, 'course-section')} data-section-name={name}>
        {$items.length === 0 && (
          <aside className={styles.empty}>
            <Trans>
              <p>
                <strong>Uh oh!</strong> This section contains no lessons or training assets (it probably should).
                <br />
                Contact the course author and ensure they have configured the curriculum section correctly.
              </p>
            </Trans>
          </aside>
        )}
        {$items}
      </section>
    )
  }
}
